import React, { useEffect, useState } from 'react'
import ChatAi from '../../componets/ChatAi'
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setIsWidth } from '../../store/slice/currentStageSlice';
import { currentStageData } from '../../store/slice/currentStageSlice';
import MapAiComponent from '../../componets/MapAiComponent';

function ChatBoat() {
  const [view, setView] = useState(null);
  const [selectedLayer, setSelectedLayer] = useState("");

    const [isScreenSize, setIsScreenSize] = useState(window.innerWidth <= 991);
    const [locationAi, setLocationAi] = useState('');
    const location = useLocation()
    const dispatch = useDispatch()

    const handleLayerSelect = (layer) => {
      setSelectedLayer(layer); // Update the selected layer
    };
    
    useEffect(()=>{
      dispatch(setIsWidth(false))
      dispatch(currentStageData(''))
      setLocationAi(location.pathname)
          const handleResize =()=>{
            setIsScreenSize(window.innerWidth <= 991)
          };

          window.addEventListener('resize', handleResize)
          return ()=> window.removeEventListener('resize', handleResize)
    },[])
   
  return (
    <>
    <div className='row'>
      <div className='col-lg-7 col-md-12 p-lg-0 px-3 '>
        <MapAiComponent isScreenSize={isScreenSize} locationAi={locationAi} selectedLayer={selectedLayer} onViewReady={(mapView) => setView(mapView)} />
      </div>
      <div className='col-lg-5 col-md-12 p-0 '>
        <ChatAi view={view}/>
      </div>
    </div>
    
    </>
  )
}

export default ChatBoat